export type DisplayTextType = 'NONE' | 'ARTICLE_TITLE' | 'POST_CAPTION';

export const DisplayText = {
  None: 'NONE' as const,
  ArticleTitle: 'ARTICLE_TITLE' as const,
  PostCaption: 'POST_CAPTION' as const,
};

export type User = {
  username: string;
  name: string;
  pictureUrl: string;
  visitLabel: string;
  visitUrl: string;
  showVisitButton: boolean;
  visitLabel2: string;
  visitUrl2: string;
  showVisitButton2: boolean;
  pageDescription?: string;
  displayTextType: DisplayTextType;
  timestamp?: number;
};

export enum MediaType {
  Link = 'link',
  Photo = 'photo',
  Video = 'video',
  Album = 'album',
  Other = 'other',
}

export type Post = {
  id: string;
  type: MediaType;
  imageUrl: string;
  smartlink: string;
  displayText: string;
  created: string;
};
